import { CartUpdatedEvent, ThemeEvents } from '@theme/events';

// NBO: eComposer "Order now" buttons are set to open eComposer's own cart popup, which
// doesn't exist on this theme (it fails with an alert). Point them at this theme's
// cart drawer instead: eComposer still adds the item, then we refresh and open the drawer.
const POPUP_SELECTOR = '[class*="ecom-"][data-action="popup"]';
const BRIDGE_ACTION = 'nbo-drawer';

function retarget(root = document) {
  root.querySelectorAll(POPUP_SELECTOR).forEach((button) => {
    button.dataset.action = BRIDGE_ACTION;
  });
}

// eComposer's global custom JS (set in the app, shared with the old theme) replaces
// ajaxCartSuccess with a jQuery call for the old theme's drawer. There is no jQuery here,
// so it throws and eComposer shows "Error$ is not defined". The drawer is opened below instead.
function neutralizeOldCartHook() {
  if (window.EComposer) window.EComposer.ajaxCartSuccess = function () {};
}

// buttons clicked before load finished, or rendered later (quick view, sliders)
document.addEventListener(
  'click',
  (event) => {
    const button = event.target.closest?.('[class*="ecom-"][data-action]');
    if (!button) return;
    if (button.dataset.action === 'popup') button.dataset.action = BRIDGE_ACTION;
    neutralizeOldCartHook();
  },
  true,
);

async function refreshDrawer() {
  if (window.location.pathname.includes('/cart')) {
    window.location.reload();
    return;
  }

  const drawer = document.querySelector('cart-drawer');
  const sectionIds = [drawer?.dataset.sectionId, 'auto-gifts'].filter(Boolean);

  try {
    const [cart, sections] = await Promise.all([
      fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json()),
      fetch(`${window.location.pathname}?sections=${sectionIds.join(',')}`).then((response) => response.json()),
    ]);

    document.dispatchEvent(new CartUpdatedEvent({}, { itemCount: cart.item_count, source: 'ecomposer', sections }));
    document.dispatchEvent(new Event(ThemeEvents.cartOpen));
  } catch (error) {
    console.error('NBO eComposer cart bridge:', error);
  }
}

document.addEventListener('ec-cart-added', refreshDrawer);

function init() {
  retarget();
  // the custom JS sets its hook 500ms after DOMContentLoaded
  [800, 2000, 5000].forEach((delay) => setTimeout(neutralizeOldCartHook, delay));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
